const actionTypeIdentifier = 'F2B8D1C4-9A7E-4F3B-B6D2-1C8E5A9F4B70';
export const sendChatMessage = `SEND-CHAT-MESSAGE-${actionTypeIdentifier}`;
export const clearChatMessage = `CLEAR-CHAT-MESSAGE-${actionTypeIdentifier}`;
export const setSpecialTask = `SET-SPECIAL-TASK-${actionTypeIdentifier}`;
export const setToggleChat = `SET-TOGGLE-CHAT-${actionTypeIdentifier}`;
export const setIsLoading = `SET-ISLOADING-${actionTypeIdentifier}`;
export const setInvoiceDetail = `SET-INVOICEDETAIL-${actionTypeIdentifier}`;